import React, { useState } from 'react';
import { BrushedLabel } from '../../../atoms/layout/BrushedLabel';
import classNames from 'classnames';
import './courseExamList.module.scss';
import { Button } from '../../../../../commonv3/components/atoms/buttons/Button';
import { CourseExamShowView, ExamSectionIndexView } from '../../../../types/courseExams';
import { ExamSectionType } from '../../../../../commonv3/types/courseExams';
import CompleteLabelSvg from './images/check_24px_outlined.svg';
import ChevronRight from './images/chevron-right.svg';
import { CourseShowView } from '../../../../types/courses';
import { CertificateModalContents } from '../../../organisms/home/notifications/CourseCompletionNotificationPane';
import { SheModal } from '../../../../../commonv3/components/molecules/layout/SheModal';
import { BodyText, Heading, LabelText } from '@sheinc/shelikes-design-system';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';

export const CourseExamList = ({ children }) => (
  <div styleName="list-wrapper">
    <div styleName="list">
      <div styleName="list-header">
        <BrushedLabel>課題にチャレンジしよう</BrushedLabel>
      </div>
      <div styleName="list-body">{children}</div>
    </div>
  </div>
);

const SectionList = ({ children }) => <div styleName="section-list">{children}</div>;
const CompleteBadge = () => <img src={CompleteLabelSvg} styleName="complete-badge" />;
const SectionTypeLabel = ({ sectionType, completed }) => {
  switch (sectionType) {
    case ExamSectionType.WRITING:
      return (
        <div styleName="section-type-label">
          {completed && <CompleteBadge />}
          <LabelText size="S" weight="bold">
            筆記試験
          </LabelText>
        </div>
      );
    case ExamSectionType.PRACTICAL:
      return (
        <div styleName="section-type-label">
          {completed && <CompleteBadge />}
          <LabelText size="S" weight="bold">
            実技試験
          </LabelText>
        </div>
      );
  }
};
const SectionItem = ({ index, section, activated, onClick }) => (
  <div styleName={classNames('section-item', { activated: activated })} onClick={activated ? onClick : undefined}>
    <BodyText>
      <div styleName="section-title-wrapper">
        <div styleName="section-type-label-wrapper">
          <span styleName="section-index">{String(index + 1).padStart(2, '0')}.</span>
          <SectionTypeLabel sectionType={section.section_type} completed={section.completed} />
        </div>
        <div styleName="section-title">{section.title}</div>
      </div>
    </BodyText>
    <img src={ChevronRight} styleName="chevron-right" />
  </div>
);

type ListItemProps = {
  exam: CourseExamShowView;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onStartClick: () => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSectionClick: (section: ExamSectionIndexView) => any;
  course: CourseShowView | null;
};
export const CourseExamListItem = ({ exam, onSectionClick, course = null }: ListItemProps) => {
  const [open, setOpen] = useState(false);
  return (
    <div styleName="list-item">
      <div styleName="list-item-header">
        <div>
          <div styleName="challenge-label">Challenge</div>
          <Heading size={GlobalStatesV3.viewport.isSp ? 'S' : 'M'}>{exam.title}</Heading>
        </div>
        {course != null && course.completed && (
          <div styleName="button-wrapper ">
            <Button
              id={'re-display-button'}
              type="normal"
              size="m"
              styleName="begin-button"
              onClick={() => setOpen(!open)}
            >
              修了証を表示する
            </Button>
          </div>
        )}
      </div>
      <SectionList>
        {exam.sections.map((section, index) => (
          <SectionItem
            key={section.id}
            index={index}
            section={section}
            activated={true}
            onClick={() => onSectionClick(section)}
          />
        ))}
      </SectionList>
      {course != null && (
        <SheModal open={open} onRequestClose={() => setOpen(!open)} id={'popup-certificate_pane'}>
          <CertificateModalContents
            course_id={course.id}
            course_title={course.title}
            certificate_image={course.completion_certificate}
          />
        </SheModal>
      )}
    </div>
  );
};
